import React from 'react';
import {FluidGridProps, Grid} from '../../atoms/Grid/Grid';
import {
  HorizontalSlider,
  HorizontalSliderProps,
} from '../HorizontalSlider/HorizontalSlider';

type EntityListProps = {
  testId?: string;
  uniqueKey: string;
  className?: string;
} & (
  | ({
      type: 'grid';
    } & FluidGridProps)
  | ({
      type: 'slider';
    } & HorizontalSliderProps)
);

export const EntityList: React.FC<React.PropsWithChildren<EntityListProps>> = ({
  testId,
  children,
  type,
  ...rest
}) => {
  if (type === 'grid') {
    return (
      <Grid
        {...rest}
        testId={testId || 'entityGrid'}
        enableEnhancedTileRendering
        enableGridLayout
      >
        {children}
      </Grid>
    );
  }
  if (type === 'slider') {
    return (
      <HorizontalSlider {...rest} dataTestId={testId || 'entitySlider'}>
        {children}
      </HorizontalSlider>
    );
  }
  return null;
};
